module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji-sp@2x.bbebbbf6.jpg";